import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHelmet = ({
  title = "Computer Center Lorentschitsch - IT-Service, Reparatur & Netzwerklösungen",
  description = "Computer Center Lorentschitsch - Ihr IT-Partner seit 1978. EDV-Dienstleistungen, Sofort-Reparatur, Netzwerklösungen, Hardware & Software.",
  keywords = "Computer Reparatur, IT-Service, EDV-Dienstleistungen, Netzwerklösungen, Hardware, Software, PC Reparatur, Laptop Reparatur, IT-Support",
  canonical = "https://lorentschitsch.at/",
  ogImage = "/img/misc/logo.png",
  ogType = "website"
}) => {
  const fullTitle = title.includes('Computer Center Lorentschitsch')
    ? title
    : `${title} | Computer Center Lorentschitsch`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={`https://lorentschitsch.at${ogImage}`} />
      <meta property="og:site_name" content="Computer Center Lorentschitsch" />
      <meta property="og:locale" content="de_AT" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`https://lorentschitsch.at${ogImage}`} />

      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Computer Center Lorentschitsch" />
      <meta name="geo.region" content="AT" />
      <meta name="geo.placename" content="Österreich" />
      <meta name="language" content="German" />
    </Helmet>
  );
};

export default SEOHelmet;
